import ReactDOM from 'react-dom';
import React from 'react';

import { IModalAlertParams } from './interface';
import CommonModal from './commonModal';

// eslint-disable-next-line import/no-cycle
import Modal from './index';

class Info extends CommonModal<IModalAlertParams> {
  render(visible: boolean, options: IModalAlertParams): void {
    const { title, onClose, content, closable, ...restProps } = options;
    ReactDOM.render(
      <Modal
        closable={closable}
        visible={visible}
        title={title}
        onClose={(): void => {
          this.destroy();
          onClose?.();
        }}
        {...restProps}
      >
        {content}
      </Modal>,
      this.modalContainer,
    );
  }
}

export default Info;
